import { DefaultFontSize } from "./theme/theme";

export const VIEW_MODE_CLASSNAME_PREFIX = "mode-";

/**
 * @enum {string}
 */
export const VIEW_MODE = {
  DESKTOP: VIEW_MODE_CLASSNAME_PREFIX + "desktop",
  DESKTOP2K: VIEW_MODE_CLASSNAME_PREFIX + "2k",
  DESKTOP4K: VIEW_MODE_CLASSNAME_PREFIX + "4k",
  MOBILE: VIEW_MODE_CLASSNAME_PREFIX + "mobile",
  TABLET: VIEW_MODE_CLASSNAME_PREFIX + "tablet",
  FULLSCREEN: VIEW_MODE_CLASSNAME_PREFIX + "fullscreen",
  TEXT_ONLY: VIEW_MODE_CLASSNAME_PREFIX + "text",
  BLIND: VIEW_MODE_CLASSNAME_PREFIX + "blind",
  DARK: VIEW_MODE_CLASSNAME_PREFIX + "dark",
  ZOOM: VIEW_MODE_CLASSNAME_PREFIX + "zoom"
};

export const SearchFontSizeDefault = 16;
export const TreeFontSizeDefault = 14;

export const remToPx = (remValue) => {
  const fontSize = ("window" in global)
    ? window.getComputedStyle(document.body).fontSize
    : DefaultFontSize;
  return remValue * parseFloat(fontSize);
};

export const emToPx = (el, emValue) => {
  let size;
  if (el) {
    const fontSize = ("window" in global)
      ? window.getComputedStyle(el).fontSize : DefaultFontSize;
    size = emValue * parseFloat(fontSize);
  }
  return size;
};
